import React from 'react';
interface IChingTabProps {
  searchTerm: string;
}
export function IChingTab({
  searchTerm
}: IChingTabProps) {
  return <div className="bg-gray-50 p-6 rounded-xl shadow-md" data-id="element-331">
      <h2 className="text-3xl font-bold text-gray-800 mb-4 pb-3 border-b-4 border-purple-600" data-id="element-332">
        I-Ching System for Acupuncture
      </h2>
      <div className="bg-white p-6 rounded-xl shadow-md mb-8" data-id="element-333">
        <p className="text-gray-700 leading-relaxed" data-id="element-334">
          The I-Ching (Book of Changes) system provides a sophisticated
          framework for understanding channel relationships through the Eight
          Trigrams (Ba Gua) and 64 Hexagrams. This ancient system helps predict
          treatment outcomes and select optimal point combinations.
        </p>
      </div>
      <div className="space-y-6" data-id="element-335">
        <div className="bg-white p-6 rounded-xl shadow-md" data-id="element-336">
          <h3 className="text-2xl font-bold text-teal-700 mb-3" data-id="element-337">
            Eight Trigrams (Ba Gua) - Fundamental Patterns
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-338">
            <div className="bg-blue-50 p-4 rounded-lg" data-id="element-339">
              <h4 className="font-semibold text-blue-800 mb-3" data-id="element-340">
                ☰ QIAN - Heaven
              </h4>
              <p className="text-sm text-blue-700 mb-2" data-id="element-341">
                <strong data-id="element-342">Nature:</strong> Pure Yang, Creative, Strong
              </p>
              <p className="text-sm text-blue-700 mb-2" data-id="element-343">
                <strong data-id="element-344">Meridians:</strong> Large Intestine, Small Intestine,
                Triple Heater
              </p>
              <p className="text-sm text-blue-700" data-id="element-345">
                <strong data-id="element-346">Clinical:</strong> Treats all yang excess conditions,
                inflammation, acute pain
              </p>
            </div>
            <div className="bg-purple-50 p-4 rounded-lg" data-id="element-347">
              <h4 className="font-semibold text-purple-800 mb-3" data-id="element-348">
                ☷ KUN - Earth
              </h4>
              <p className="text-sm text-purple-700 mb-2" data-id="element-349">
                <strong data-id="element-350">Nature:</strong> Pure Yin, Receptive, Nourishing
              </p>
              <p className="text-sm text-purple-700 mb-2" data-id="element-351">
                <strong data-id="element-352">Meridians:</strong> Spleen, Kidney, Liver
              </p>
              <p className="text-sm text-purple-700" data-id="element-353">
                <strong data-id="element-354">Clinical:</strong> Treats deficiency, chronic
                conditions, nourishment
              </p>
            </div>
            <div className="bg-green-50 p-4 rounded-lg" data-id="element-355">
              <h4 className="font-semibold text-green-800 mb-3" data-id="element-356">
                ☳ ZHEN - Thunder
              </h4>
              <p className="text-sm text-green-700 mb-2" data-id="element-357">
                <strong data-id="element-358">Nature:</strong> Movement, Initiative, Arousing
              </p>
              <p className="text-sm text-green-700 mb-2" data-id="element-359">
                <strong data-id="element-360">Meridians:</strong> Liver, Gallbladder
              </p>
              <p className="text-sm text-green-700" data-id="element-361">
                <strong data-id="element-362">Clinical:</strong> Moves stagnation, treats Wood
                imbalances, anger
              </p>
            </div>
            <div className="bg-blue-50 p-4 rounded-lg" data-id="element-363">
              <h4 className="font-semibold text-blue-800 mb-3" data-id="element-364">
                ☵ KAN - Water
              </h4>
              <p className="text-sm text-blue-700 mb-2" data-id="element-365">
                <strong data-id="element-366">Nature:</strong> Danger, Depth, Flowing
              </p>
              <p className="text-sm text-blue-700 mb-2" data-id="element-367">
                <strong data-id="element-368">Meridians:</strong> Kidney, Bladder
              </p>
              <p className="text-sm text-blue-700" data-id="element-369">
                <strong data-id="element-370">Clinical:</strong> Treats fear, urinary issues, essence
                deficiency
              </p>
            </div>
            <div className="bg-red-50 p-4 rounded-lg" data-id="element-371">
              <h4 className="font-semibold text-red-800 mb-3" data-id="element-372">☲ LI - Fire</h4>
              <p className="text-sm text-red-700 mb-2" data-id="element-373">
                <strong data-id="element-374">Nature:</strong> Clarity, Attachment, Illuminating
              </p>
              <p className="text-sm text-red-700 mb-2" data-id="element-375">
                <strong data-id="element-376">Meridians:</strong> Heart, Small Intestine
              </p>
              <p className="text-sm text-red-700" data-id="element-377">
                <strong data-id="element-378">Clinical:</strong> Treats shen disturbances, insomnia,
                anxiety
              </p>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg" data-id="element-379">
              <h4 className="font-semibold text-gray-800 mb-3" data-id="element-380">
                ☶ GEN - Mountain
              </h4>
              <p className="text-sm text-gray-700 mb-2" data-id="element-381">
                <strong data-id="element-382">Nature:</strong> Stillness, Keeping Still, Stability
              </p>
              <p className="text-sm text-gray-700 mb-2" data-id="element-383">
                <strong data-id="element-384">Meridians:</strong> Stomach, Spleen
              </p>
              <p className="text-sm text-gray-700" data-id="element-385">
                <strong data-id="element-386">Clinical:</strong> Treats digestive issues, worry,
                overthinking
              </p>
            </div>
            <div className="bg-teal-50 p-4 rounded-lg" data-id="element-387">
              <h4 className="font-semibold text-teal-800 mb-3" data-id="element-388">
                ☴ XUN - Wind
              </h4>
              <p className="text-sm text-teal-700 mb-2" data-id="element-389">
                <strong data-id="element-390">Nature:</strong> Gentle, Penetrating, Dispersing
              </p>
              <p className="text-sm text-teal-700 mb-2" data-id="element-391">
                <strong data-id="element-392">Meridians:</strong> Gallbladder, Liver
              </p>
              <p className="text-sm text-teal-700" data-id="element-393">
                <strong data-id="element-394">Clinical:</strong> Disperses wind, treats migraines,
                lateral pain
              </p>
            </div>
            <div className="bg-yellow-50 p-4 rounded-lg" data-id="element-395">
              <h4 className="font-semibold text-yellow-800 mb-3" data-id="element-396">
                ☱ DUI - Lake
              </h4>
              <p className="text-sm text-yellow-700 mb-2" data-id="element-397">
                <strong data-id="element-398">Nature:</strong> Joy, Exchange, Pleasure
              </p>
              <p className="text-sm text-yellow-700 mb-2" data-id="element-399">
                <strong data-id="element-400">Meridians:</strong> Lung, Large Intestine
              </p>
              <p className="text-sm text-yellow-700" data-id="element-401">
                <strong data-id="element-402">Clinical:</strong> Treats respiratory issues, grief,
                skin problems
              </p>
            </div>
          </div>
        </div>
        <div className="bg-white p-6 rounded-xl shadow-md" data-id="element-403">
          <h3 className="text-2xl font-bold text-teal-700 mb-3" data-id="element-404">
            Six Balance Methods Using I-Ching
          </h3>
          <div className="bg-blue-50 p-4 rounded-lg mb-4" data-id="element-405">
            <p className="text-blue-700" data-id="element-406">
              The I-Ching system provides six methods to balance channel pairs,
              corresponding to the six systems of Balance Method. Each method
              uses trigram relationships to determine point selection.
            </p>
          </div>
          <div className="space-y-4" data-id="element-407">
            <div className="bg-purple-50 p-4 rounded-lg" data-id="element-408">
              <h4 className="font-semibold text-purple-800 mb-2" data-id="element-409">
                1. Channel Pairs (Yin-Yang Pairing)
              </h4>
              <p className="text-sm text-purple-700" data-id="element-410">
                Based on trigram complementarity. Treats one channel by needling
                its paired channel. Uses opposite side needling.
              </p>
              <div className="mt-2 flex flex-wrap gap-2" data-id="element-411">
                <span className="px-2 py-1 bg-purple-200 text-purple-800 rounded text-xs" data-id="element-412">
                  LU ↔ LI
                </span>
                <span className="px-2 py-1 bg-purple-200 text-purple-800 rounded text-xs" data-id="element-413">
                  ST ↔ SP
                </span>
                <span className="px-2 py-1 bg-purple-200 text-purple-800 rounded text-xs" data-id="element-414">
                  HT ↔ SI
                </span>
                <span className="px-2 py-1 bg-purple-200 text-purple-800 rounded text-xs" data-id="element-415">
                  BL ↔ KI
                </span>
                <span className="px-2 py-1 bg-purple-200 text-purple-800 rounded text-xs" data-id="element-416">
                  PC ↔ TH
                </span>
                <span className="px-2 py-1 bg-purple-200 text-purple-800 rounded text-xs" data-id="element-417">
                  GB ↔ LR
                </span>
              </div>
            </div>
            <div className="bg-green-50 p-4 rounded-lg" data-id="element-418">
              <h4 className="font-semibold text-green-800 mb-2" data-id="element-419">
                2. Stream and Sea Points
              </h4>
              <p className="text-sm text-green-700" data-id="element-420">
                Uses Five Shu points based on hexagram transformations. Stream
                points (Shu) and Sea points (He) create powerful balancing
                effects.
              </p>
            </div>
            <div className="bg-orange-50 p-4 rounded-lg" data-id="element-421">
              <h4 className="font-semibold text-orange-800 mb-2" data-id="element-422">
                3. Daily Clock Method
              </h4>
              <p className="text-sm text-orange-700" data-id="element-423">
                Based on the Chinese Clock and hexagram timing. Treats channels
                at their peak or ebb times for maximum effect.
              </p>
            </div>
          </div>
        </div>
        <div className="bg-white p-6 rounded-xl shadow-md" data-id="element-424">
          <h3 className="text-2xl font-bold text-teal-700 mb-3" data-id="element-425">
            Favorable Hexagrams for Treatment
          </h3>
          <div className="bg-blue-50 p-4 rounded-lg mb-4" data-id="element-426">
            <p className="text-blue-700" data-id="element-427">
              Certain hexagrams indicate favorable treatment outcomes. These
              hexagrams guide point selection and predict treatment success.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-428">
            <div className="bg-green-50 p-4 rounded-lg" data-id="element-429">
              <h4 className="font-semibold text-green-800 mb-2" data-id="element-430">
                ䷀ Hexagram 1 - QIAN (Heaven)
              </h4>
              <p className="text-sm text-green-700" data-id="element-431">
                Pure yang energy. Excellent for acute conditions, pain relief,
                inflammation. Use yang channels.
              </p>
            </div>
            <div className="bg-blue-50 p-4 rounded-lg" data-id="element-432">
              <h4 className="font-semibold text-blue-800 mb-2" data-id="element-433">
                ䷊ Hexagram 11 - TAI (Peace)
              </h4>
              <p className="text-sm text-blue-700" data-id="element-434">
                Heaven and Earth in harmony. Ideal for balancing yin and yang,
                treating chronic conditions.
              </p>
            </div>
            <div className="bg-purple-50 p-4 rounded-lg" data-id="element-435">
              <h4 className="font-semibold text-purple-800 mb-2" data-id="element-436">
                ䷌ Hexagram 13 - TONG REN (Fellowship)
              </h4>
              <p className="text-sm text-purple-700" data-id="element-437">
                Unity and cooperation. Good for systemic treatments, multiple
                channel involvement.
              </p>
            </div>
            <div className="bg-yellow-50 p-4 rounded-lg" data-id="element-438">
              <h4 className="font-semibold text-yellow-800 mb-2" data-id="element-439">
                ䷒ Hexagram 19 - LIN (Approach)
              </h4>
              <p className="text-sm text-yellow-700" data-id="element-440">
                Growth and progress. Favorable for chronic diseases, building
                strength, tonification.
              </p>
            </div>
            <div className="bg-red-50 p-4 rounded-lg" data-id="element-441">
              <h4 className="font-semibold text-red-800 mb-2" data-id="element-442">
                ䷩ Hexagram 42 - YI (Increase)
              </h4>
              <p className="text-sm text-red-700" data-id="element-443">
                Enhancement and growth. Excellent for deficiency patterns,
                building qi and blood.
              </p>
            </div>
            <div className="bg-teal-50 p-4 rounded-lg" data-id="element-444">
              <h4 className="font-semibold text-teal-800 mb-2" data-id="element-445">
                ䷼ Hexagram 61 - ZHONG FU (Inner Truth)
              </h4>
              <p className="text-sm text-teal-700" data-id="element-446">
                Sincerity and truth. Good for shen disturbances,
                mental-emotional issues, heart conditions.
              </p>
            </div>
          </div>
        </div>
        <div className="bg-white p-6 rounded-xl shadow-md" data-id="element-447">
          <h3 className="text-2xl font-bold text-teal-700 mb-3" data-id="element-448">
            36 Key Hexagram Points
          </h3>
          <div className="bg-blue-50 p-4 rounded-lg mb-4" data-id="element-449">
            <p className="text-blue-700" data-id="element-450">
              Dr. Tan identified 36 key acupuncture points that correspond to
              specific hexagrams. These points create powerful treatment effects
              when used according to I-Ching principles.
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-id="element-451">
            {['LU-7', 'LU-9', 'LI-4', 'LI-11', 'ST-36', 'ST-41', 'SP-6', 'SP-9', 'HT-7', 'HT-3', 'SI-3', 'SI-8', 'BL-40', 'BL-60', 'KI-3', 'KI-10', 'PC-6', 'PC-7', 'TH-5', 'TH-10', 'GB-34', 'GB-41', 'LR-3', 'LR-8', 'GV-20', 'GV-14', 'REN-4', 'REN-6', 'REN-12', 'REN-17', 'EX-HN3', 'EX-LE5', 'T22.05', 'T22.04', 'T77.18', 'T77.21'].map(point => <div key={point} className="bg-purple-50 p-3 rounded-lg text-center" data-id="element-452">
                <span className="font-mono text-purple-800 font-semibold" data-id="element-453">
                  {point}
                </span>
              </div>)}
          </div>
        </div>
        <div className="bg-white p-6 rounded-xl shadow-md" data-id="element-454">
          <h3 className="text-2xl font-bold text-teal-700 mb-3" data-id="element-455">
            Clinical Application of I-Ching System
          </h3>
          <div className="space-y-3" data-id="element-456">
            <div className="bg-blue-50 p-4 rounded-lg" data-id="element-457">
              <h4 className="font-semibold text-blue-800 mb-2" data-id="element-458">
                Step 1: Identify the Trigram Pattern
              </h4>
              <p className="text-sm text-blue-700" data-id="element-459">
                Determine which trigram(s) correspond to the affected channels
                and symptoms. Consider the elemental nature and yin-yang
                quality.
              </p>
            </div>
            <div className="bg-green-50 p-4 rounded-lg" data-id="element-460">
              <h4 className="font-semibold text-green-800 mb-2" data-id="element-461">
                Step 2: Select Balancing Hexagram
              </h4>
              <p className="text-sm text-green-700" data-id="element-462">
                Choose a favorable hexagram that addresses the imbalance. Look
                for hexagrams that transform the pathological pattern into a
                harmonious one.
              </p>
            </div>
            <div className="bg-purple-50 p-4 rounded-lg" data-id="element-463">
              <h4 className="font-semibold text-purple-800 mb-2" data-id="element-464">
                Step 3: Apply Corresponding Points
              </h4>
              <p className="text-sm text-purple-700" data-id="element-465">
                Use the 36 key hexagram points that align with your selected
                hexagram. Combine with Balance Method principles for optimal
                results.
              </p>
            </div>
            <div className="bg-orange-50 p-4 rounded-lg" data-id="element-466">
              <h4 className="font-semibold text-orange-800 mb-2" data-id="element-467">
                Step 4: Consider Timing
              </h4>
              <p className="text-sm text-orange-700" data-id="element-468">
                Apply treatments according to the Chinese Clock and hexagram
                timing for enhanced effectiveness. Some hexagrams are more
                powerful at certain times.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-orange-50 border-l-4 border-orange-500 p-6 mt-8" data-id="element-469">
        <strong className="text-orange-800 text-lg" data-id="element-470">
          Advanced I-Ching Integration:
        </strong>
        <ul className="mt-3 space-y-2 text-orange-700" data-id="element-471">
          <li data-id="element-472">
            • Combine I-Ching hexagrams with the Five Systems for sophisticated
            point selection
          </li>
          <li data-id="element-473">
            • Use favorable hexagrams to predict and enhance treatment outcomes
          </li>
          <li data-id="element-474">
            • Apply trigram principles to understand deep channel relationships
          </li>
          <li data-id="element-475">
            • Layer I-Ching points with Global Balance and Seasonal Balance for
            maximum effect
          </li>
          <li data-id="element-476">
            • Study hexagram transformations to understand disease progression
            and resolution
          </li>
        </ul>
      </div>
    </div>;
}